import {createAsyncThunk} from "@reduxjs/toolkit";
import { getRecentSearches } from "../recentSearchService/index.js";
import {getSavedSearches} from "../savedSearchService/index.js";

// Create a thunk that will be called when the component mounts
export const loadSearchMetaData = createAsyncThunk(
  'enhancedSearch/loadSearchMetaData',
  async () => {
    try {
      return {
          recentSearches: getRecentSearches(),
          savedSearches: getSavedSearches(),
      };
    } catch (error) {
      return { };
    }
  }
);